export default __webpack_public_path__ + "static/media/key gold.0eaf0732.png";